/**
 * Created by Owner on 2016/8/8.
 */
import {Component, Input, Output, EventEmitter} from '@angular/core';
import {LotteryService} from "../../services/lottery.services";
import {AppConfigService} from "../../services/appConfig.service";
import {LoadingController} from "ionic-angular";
import {LotteryPage} from "../../pages/lottery/lottery";

@Component({
    selector: 'helper-page',
    templateUrl: 'helper.html',
    // providers: [LotteryService, AppConfigService]
})
export class HelperPage {
    methodexample: string = "";
    exampleInfo: string = "";
    methodhelp: string = "";
    isSMorTD: boolean = false;

    _activeLottery: any;
    @Input()
    set activeLottery(activeLotteryInit: any) {
        if (!activeLotteryInit) {
            return;
        }
        this._activeLottery = activeLotteryInit;
        if (activeLotteryInit.hasOwnProperty("methodexample")) {
            this.methodexample = activeLotteryInit.methodexample;
            this.exampleInfo = activeLotteryInit.exampleInfo;
        }
        if (activeLotteryInit.hasOwnProperty("methodhelp")) {
            this.methodhelp = activeLotteryInit.methodhelp;
        }
    }

    get activeLottery() {
        return this._activeLottery;
    }

    _dropPanelShow: boolean;

    @Input()
    set dropPanelShow(flag: boolean) {
        this._dropPanelShow = flag;
    }

    get dropPanelShow() {
        return this._dropPanelShow;
    }

    @Output()
    dropPanelShowChange: EventEmitter<any> = new EventEmitter();

    constructor(public loadingCtrl: LoadingController) {
        this.isSMorTD = LotteryPage.isSMorTD;
    }

    //关闭面板
    hidePanel() {
        this.dropPanelShowChange.emit(false);
        this.dropPanelShow = false;
    }
}



// WEBPACK FOOTER //
// ./src/component/helper/helper.ts